const EMBEDDED_APP_CONFIG_SCRIPT_ID = "rstv-embedded-app-config";
const EMBEDDED_INSTANCE_META_NAME = "rstv-instance-id";

declare global {
  interface Window {
    __EMBEDDED_APP_CONFIG__?: Record<string, unknown>;
  }
}

function escapeInlineJson(value: Record<string, unknown>) {
  return JSON.stringify(value)
    .replace(/</g, "\\u003c")
    .replace(/-->/g, "--\\>")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}

function readEmbeddedAppConfigFromDom() {
  if (typeof document === "undefined") {
    return null;
  }

  const script = document.getElementById(
    EMBEDDED_APP_CONFIG_SCRIPT_ID
  ) as HTMLScriptElement | null;

  if (!script?.textContent) {
    return null;
  }

  try {
    return JSON.parse(script.textContent) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function getEmbeddedAppConfig() {
  if (typeof window === "undefined") {
    return null;
  }

  const embeddedConfig =
    window.__EMBEDDED_APP_CONFIG__ ?? readEmbeddedAppConfigFromDom();

  if (embeddedConfig) {
    window.__EMBEDDED_APP_CONFIG__ = embeddedConfig;
  }

  return embeddedConfig ?? null;
}

export function persistEmbeddedAppConfig(config: Record<string, unknown> | null) {
  if (typeof window !== "undefined") {
    window.__EMBEDDED_APP_CONFIG__ = config ?? undefined;
  }

  if (typeof document === "undefined") {
    return;
  }

  const existingScript = document.getElementById(EMBEDDED_APP_CONFIG_SCRIPT_ID);
  const existingMeta = document.querySelector(
    `meta[name="${EMBEDDED_INSTANCE_META_NAME}"]`
  );

  if (!config) {
    existingScript?.remove();
    existingMeta?.remove();
    return;
  }

  const serializedConfig = escapeInlineJson(config);
  const instanceId = String(config.instanceId ?? config.id ?? "");

  const script =
    (existingScript as HTMLScriptElement | null) ??
    document.createElement("script");
  script.id = EMBEDDED_APP_CONFIG_SCRIPT_ID;
  script.type = "application/json";
  script.textContent = serializedConfig;

  if (!existingScript) {
    document.head.appendChild(script);
  }

  const meta =
    (existingMeta as HTMLMetaElement | null) ?? document.createElement("meta");
  meta.setAttribute("name", EMBEDDED_INSTANCE_META_NAME);
  meta.setAttribute("content", instanceId);

  if (!existingMeta) {
    document.head.appendChild(meta);
  }
}
